module.exports = __webpack_public_path__ + "img/skull_16_bj.d6512c0a.png";